import { memo } from "react";
import PropTypes from "prop-types";
import "./AvailablePaymentTerms.scss";
import { FormattedMessage } from "react-intl";
import IconPaiement2x from "app/pages/.shared/static/icons/IconPaiement2x";
import IconPaiement4x from "app/pages/.shared/static/icons/IconPaiement4x";
import IconPaiement10x from "app/pages/.shared/static/icons/IconPaiement10x";
import IconDeposit from "app/pages/.shared/IconDeposit";
import IconLogoAlma from "app/pages/.shared/static/icons/IconLogoAlma";
import { PAYMENT_OPTIONS } from "app/constants";

const AvailablePaymentTerms = ({
	availablePaymentTerms = [],
	isDepositEnabled = false,
	hasAlmaPayment = false,
}) => {
	return (
		availablePaymentTerms.length > 1 && (
			<div className="available-payment-terms" data-testid="available-payment-terms">
				<div className="available-payment-terms__title">
					<FormattedMessage id="available.payment.terms.prefix" />
				</div>

				<div className="available-payment-terms__pictos">
					{availablePaymentTerms.map(term => {
						let picto = false;

						if (term === PAYMENT_OPTIONS["2x"]) {
							if (isDepositEnabled) {
								picto = <IconDeposit />;
							} else {
								picto = <IconPaiement2x />;
							}
						} else if (term === PAYMENT_OPTIONS["4x"]) {
							picto = <IconPaiement4x />;
						} else if (term === PAYMENT_OPTIONS["10x"]) {
							picto = <IconPaiement10x />;
						}

						return (
							<div key={term} className="available-payment-terms__picto">
								{picto}
							</div>
						);
					})}
					{hasAlmaPayment && (
						<div className="available-payment-terms__picto">
							<IconLogoAlma />
						</div>
					)}
				</div>
			</div>
		)
	);
};

AvailablePaymentTerms.propTypes = {
	availablePaymentTerms: PropTypes.array,
	isDepositEnabled: PropTypes.bool,
	hasAlmaPayment: PropTypes.bool,
};

export default memo(AvailablePaymentTerms);
